import anime from 'animejs/lib/anime.es.js'
import { clamp } from './math'

;(function() {
    if (document.getElementById('js-Wall')) {
        let root = document.getElementById('js-Wall');
        let wall_animation = anime({
            targets: root.getElementById('js-Wall-wall'),
            opacity: [1, 0],
            easing: "cubicBezier(0.335, 0, 0.335, 1)",
            endDelay: 1000,
            duration: 3000,
            autoplay: false,
        });

        let star_animation = anime({
            targets: root.getElementById('js-Wall-star'),
            translateY: [-50, 0],
            opacity: [0, 1],
            easing: "cubicBezier(0.335, 0, 0.335, 1)",
            delay: 2000,
            endDelay: 1000,
            duration: 1000,
            autoplay: false,
        });

        function transition() {
            let rect = root.getBoundingClientRect();
            let window_quarter_height = window.innerHeight * 0.25
            let t = 1 - clamp(((rect.y + (rect.height / 2)) - window_quarter_height) / (window.innerHeight - window_quarter_height * 2), 0, 1);
            wall_animation.seek(t * wall_animation.duration);
            star_animation.seek(t * star_animation.duration);
        }

        let observer = new IntersectionObserver(function(entries, observer) {
            for (let i = 0; i < entries.length; ++i) {
                let entry = entries[i]
                if (entry.intersectionRatio >= 1.0) {
                    window.addEventListener('scroll', transition);
                } else if (entry.intersectionRatio <= 0.0) {
                    window.removeEventListener('scroll', transition);
                }
            }
        }, { root: null, rootMargin: '0px', threshold: [0.0, 1.0] });

        observer.observe(root);
    }
}());


;(function() {
    if (document.querySelectorAll('.js-Checkmark').length > 0) {
        anime({
            targets: '.js-Checkmark path',
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: 'cubicBezier(0.335, 0, 0.335, 1)',
            duration: 400,
            delay: function(el, i) { return (i + 1) * 125 },
        });
    }
}());

;(function() {
    if (document.getElementById('js-Search')) {
        let timeline = anime.timeline({
            loop: true,
            easing: 'cubicBezier(0.335, 0, 0.335, 1)',
            duration: 1000
        })

        timeline
            .add({
                targets: '#input00',
                transform: [
                    { value: 'translate(0 0) scale(0.85)' },
                    { value: 'translate(0 0) scale(1.00)'}
                ],
                duration: 300
            })
            .add({
                targets: '#input00-box00',
                x: -150,
                width: 298,
                rx: 7,
                duration: 1000
            })
            .add({
                targets: '#input00-icon00',
                x: -130
            }, '-=1000')
            .add({
                targets: '#input00-text00',
                transform: 'translate(-200 -118)'
            }, '-=1000')
            .add({
                targets: '#input00-text00-letters00 path',
                opacity: [
                    { value: 0 },
                    { value: 1, duration: 0 }
                ],
                transform: [
                    { value: 'translate(0 -5)' },
                    { value: 'translate(0 0)', duration: 43.75 }
                ],
                delay: anime.stagger(87.5),
            }, '-=1000')
            .add({
                targets: '#search00',
                transform: 'translate(194 47.9) scale(0.65)',
                duration: 500
            })
            .add({
                targets: '#result00',
                opacity: 1,
                duration: 500
            }, '-=250')
            .add({
                targets: '#result01',
                opacity: 1,
                duration: 500
            }, '-=250')
            .add({
                targets: '#input00',
                opacity: 0,
                duration: 500
            })
            .add({
                targets: '#result00',
                opacity: 0,
                duration: 500
            }, '-=250')
            .add({
                targets: '#search00',
                transform: 'translate(194 -66.5) scale(0.65)',
                duration: 500
            }, '-=500')
            .add({
                targets: '#result02',
                opacity: 1,
                duration: 500,
                endDelay: 250
            }, '-=250')
            .add({
                targets: '#result01, #result02',
                opacity: 0,
                duration: 500,
                endDelay: 250
            })
            .add({
                targets: '#input01',
                opacity: 1,
                endDelay: 500
            }, '-=500')
    }
}())


;(function() {

    if (document.getElementById('js-Tasks')) {
        let timeline = anime.timeline({
            loop: true,
            easing: 'cubicBezier(0.335, 0, 0.335, 1)',
            duration: 1000
        })

        let slide_duration = 1500
        let slide_transition = 750
        let slide_enddelay = slide_duration-slide_transition

        for (let i = 0; i < 6; ++i) {
            timeline
                .add({
                    targets: `#task0${i}-checkbox`,
                    strokeDashoffset: 0,
                    duration: slide_transition
                }, i*slide_duration)
                .add({
                    targets: `#task0${i}-title`,
                    fill: '#cccccc',
                    duration: slide_transition
                }, i*slide_duration)
                .add({
                    targets: `#task0${i}-checkmark`,
                    strokeDashoffset: 0,
                    duration: slide_transition-250
                }, i*slide_duration)
                .add({
                    targets: `#task0${i}`,
                    opacity: 0,
                    delay: slide_transition,
                    duration: slide_enddelay
                }, i*slide_duration)
                // @NOTE(Grey): Resets so it comes in without being checked
                .add({
                    targets: `#task0${((i+3)%6)}-checkbox`,
                    strokeDashoffset: -160,
                    delay: slide_duration,
                    duration: 0
                }, i*slide_duration)
                .add({
                    targets: `#task0${((i+3)%6)}-title`,
                    fill: '#ffffff',
                    delay: slide_duration,
                    duration: 0
                }, i*slide_duration)
                .add({
                    targets: `#task0${((i+3)%6)}-checkmark`,
                    strokeDashoffset: 34,
                    delay: slide_duration,
                    duration: 0
                }, i*slide_duration)
                // @NOTE(Grey): Fade the bottom one up
                .add({
                    targets: `#task0${((i+3)%6)}`,
                    opacity: 1,
                    delay: slide_transition,
                    duration: slide_enddelay,
                }, i*slide_duration)
        }

        timeline
            // @NOTE(Grey): Orchestration
            .add({
                targets: '#tasklist00',
                transform: [
                    { value: 'translate(194 74)' , delay: slide_transition, duration: slide_enddelay },
                    { value: 'translate(194 26)' , delay: slide_transition, duration: slide_enddelay },
                    { value: 'translate(194 -22)', delay: slide_transition, duration: slide_enddelay },

                    { value: 'translate(194 266)', duration: 0 },
                    { value: 'translate(194 218)', delay: slide_transition, duration: slide_enddelay },
                    { value: 'translate(194 170)', delay: slide_transition, duration: slide_enddelay },

                    { value: 'translate(194 122)', delay: slide_transition, duration: slide_enddelay }
                ]
            }, 0)
            .add({
                targets: '#tasklist01',
                transform: [
                    { value: 'translate(194 218)', delay: slide_transition, duration: slide_enddelay },
                    { value: 'translate(194 170)', delay: slide_transition, duration: slide_enddelay },
                    { value: 'translate(194 122)', delay: slide_transition, duration: slide_enddelay },

                    { value: 'translate(194 74)' , delay: slide_transition, duration: slide_enddelay },
                    { value: 'translate(194 26)' , delay: slide_transition, duration: slide_enddelay },
                    { value: 'translate(194 -22)', delay: slide_transition, duration: slide_enddelay },

                    { value: 'translate(194 266)', duration: 0 }
                ]
            }, 0)
    }

}())



